module.exports = __webpack_public_path__ + "static/06-5ecb63663e45635791b030acf00f2b24.jpg";